<template>
    <BasePanel
        :headline="$t('lang_CONTRACTS_LABEL_PANEL_CAPTION_ADVANCE') + ' (' + $t('lang_GENERIC_CAPTION_BETA_DO_NOT_USE') + ')'"
        :alvqa="alvqa"
    >
        <template v-slot:panelContent>
            <v-data-table
                :headers="headers"
                :items="listItems"
                hide-default-footer
                :items-per-page="300"
                :header-props="{ sortIcon: '' }"
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                class="noMinWidth"
            >
            <!-- TOP SLOT -->
                <template v-slot:top>
                    <v-row class="pb-3">
                        <v-spacer></v-spacer>
                        <v-col 
                            cols="3"
                            align-self="end"
                        >
                            <BaseButton 
                                @click="addNewRow"
                                :disabled="$route.params.alvId === 'new'"
                                label="lang_GENERAL_BUTTON_ADD_ROW"
                                block
                                :alvqa="alvqa + '-button-add-row'"
                            />
                        </v-col>
                    </v-row>
                </template>

            <!-- Headers -->
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                    <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>

            <!-- Items -->
                <template v-slot:[`item.description`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-description'">
                        {{ item.description }}
                    </div>
                </template>
                <template v-slot:[`item.enteredBy`]="{ item }">
                    <BaseTooltip>
                        <template v-slot:content>
                            <div
                                class="ellipsis"
                                :alvqa="alvqa + '-list-row-text-entered-by'"
                            >
                                {{ enteredByText(item) }}
                            </div>
                        </template>
                        <template v-slot:text>{{ enteredByText(item) }}</template>
                    </BaseTooltip>
                </template>
                <template v-slot:[`item.amount`]="{ item }">
                    <div 
                        class="text-right"
                        :alvqa="alvqa + '-list-row-text-amount'"
                    >
                        {{ $alvPlugin.formatMoney(item.amount) }}
                    </div>
                </template>
                <template v-slot:[`item.balance`]="{ item }">
                    <div 
                        class="text-right"
                        :alvqa="alvqa + '-list-row-text-balance'"
                    >
                        {{ $alvPlugin.formatMoney(item.balance) }}
                    </div>
                </template>

            <!-- Buttons -->
                <template v-slot:[`item.inlineEdit`]="{ item }">
                    <BaseIcon   
                        :alvqa="alvqa + '-list-row-icon-inline-edit'"
                        icon="edit" 
                        tooltipText="lang_GENERAL_CAPTION_ICON_EDIT"   
                        @click.stop="editInlineFunction(item)"
                    />
                </template>
                <template v-slot:[`item.delete`]="{ item }">
                    <BaseIcon 
                        @click="deleteRow(item)"
                        icon="delete"
                        color="iconDelete"
                        tooltipText="lang_GENERIC_CAPTION_DELETE"
                        :alvqa="alvqa + 'list-row-icon-delete'"
                    />
                </template>
            </v-data-table>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseIcon from '@/components/_buttons/BaseIcon'
import BaseTooltip from '@/components/_base/BaseTooltip'

export default {
    name: "PublishingContractsAdvanceEditPanel",
    components: {
        BasePanel,
        BaseButton,
        BaseIcon,
        BaseTooltip
    },
    data() {
        return {
            alvqa: 'contracts-publishing-edit-form-panel-advance'
        }
    },
    computed: {
        headers() {
            return [
                {
                    text: this.$t("lang_GENERIC_CAPTION_DESCRIPTION"), 
                    align: "left", 
                    value: "description",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-description'
                },
                {
                    text: this.$t("lang_LABEL_CONTRACTS_ADVANCE_ENETERED"), 
                    align: "left", 
                    value: "enteredBy",
                    class: 'text-no-wrap',
                    sortable: false,
                    width: "160px",
                    alvqa: this.alvqa + '-header-entered-by'
                },
                {
                    text: this.$t("lang_GENERIC_CAPTION_AMOUNT") + ' ' + this.$store.getters.getSelectedCurrency, 
                    align: "right", 
                    value: "amount",
                    class: 'text-no-wrap',
                    sortable: false,
                    width: "130px",
                    alvqa: this.alvqa + '-header-amount'
                },
                {
                    text: this.$t("lang_GENERIC_CAPTION_BALANCE") + ' ' + this.$store.getters.getSelectedCurrency, 
                    align: "right", 
                    value: "balance",
                    class: 'text-no-wrap',
                    sortable: false,
                    width: "130px",
                    alvqa: this.alvqa + '-header-balance'
                },
                {
                    text: '', 
                    value: 'inlineEdit',
                    align: 'right',
                    sortable: false,
                    width: "70px",
                    class: 'text-no-wrap'
                },
                {
                    text: "",
                    align: "right",
                    width: "70px",
                    value: "delete",
                    sortable: false,
                    class: 'text-no-wrap'
                }
            ]
        },
        listItems() { return this.$store.getters.getPublishingContractsAdvance }
    },
    methods: {
        getEnteredTranslation(enteredValue) {
            if(enteredValue === 'manual') return this.$t('lang_GENERIC_CAPTION_MANUAL')
            if(enteredValue === 'automatic') return this.$t('lang_GENERIC_CAPTION_AUTOMATIC')
        },
        enteredByText(item) {
            const date = item.enteredOn !== null ? this.$d(new Date(item.enteredOn), 'alvDateTime') : ''
            const mode = this.getEnteredTranslation(item.entered)
            return `${mode}, ${item.enteredBy} ${this.$t('lang_GENERIC_CAPTION_ON')} ${date}`
        },
        addNewRow() {
            this.$store.commit('setSelectedPublishingContractsAdvance', [])
            this.$store.commit('setShowPublishingContractsAdvanceEditingDialog', true)
            this.$store.commit('setEditingDialogHeadline', this.$t('lang_GENERAL_CAPTION_NEW_ENTRY'))

            let defaultValues = JSON.parse(JSON.stringify(this.$store.getters.getDefaultPublishingContractsAdvance)) 
            this.$store.commit('setPublishingContractsAdvanceEditingDialogDetails', defaultValues)
        },
        editInlineFunction(item) {
            this.$store.commit('setSelectedPublishingContractsAdvance', item.id)
            let detailsDeepCopy = JSON.parse(JSON.stringify(item))

            detailsDeepCopy['amount'] = this.$n(detailsDeepCopy['amount'], 'number')

            this.$store.commit('setPublishingContractsAdvanceEditingDialogDetails', detailsDeepCopy)
            this.$store.commit('setEditingDialogHeadline', this.$t("lang_GENERAL_CAPTION_EDITING_ENTRY"))
            this.$store.commit('setShowPublishingContractsAdvanceEditingDialog', true) 
        },
        deleteRow(item) {
            this.$store.commit("setSelectedPublishingContractsAdvance", item)
            this.$store.commit('setDeletionDialogContext', 'SelectedPublishingContractsAdvance')
            this.$store.commit('setShowDeletionDialog', true)
        },
    }
}
</script>
